export const accountInfo = state => state.accountInfo
export const systemInfo = state => state.systemInfo

export const isAdmin = state => state.isAdmin
export const isNewUser = state => state.isNewUser
export const createStep = state => state.createStep

export const publicationInfo = state => state.publicationInfo

export const magazineList = state => state.magazineList
export const magazineConfig = state => state.magazineConfig
export const magazineInfo = state => state.magazineInfo
export const libInfo = state => state.libInfo
export const libList = state => state.libList
export const notIncludedProviders = state => state.notIncludedProviders